export default __webpack_public_path__ + "static/media/padicon.1c7ff773.png";